var arrMax = require('../array/max');
var values = require('./values');

    /**
     * Returns maximum value inside object.
     */
    function max(obj, compareFn) {
        return arrMax(values(obj), compareFn);
    }

    module.exports = max;




//////////////////
// WEBPACK FOOTER
// ./node_modules/mout/object/max.js
// module id = 5l6n
// module chunks = 0